import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { jiraApiRef } from '../api/JiraApi';
import { buildJql } from '../api/jql';
import type { JiraAnnotations } from '../api/jql';
import type { JiraIssue } from '../api/JiraApi';

export function useJiraIssues(annotations: JiraAnnotations): {
  issues: JiraIssue[];
  loading: boolean;
  error?: Error;
} {
  const jiraApi = useApi(jiraApiRef);
  const jql = buildJql(annotations);

  const { value, loading, error } = useAsync(async () => {
    return jiraApi.searchIssues({ jql });
  }, [jiraApi, jql]);

  return {
    issues: value ?? [],
    loading,
    error: error as Error | undefined,
  };
}
